import React from 'react';

interface ControlsModalProps {
  onClose: () => void;
}

// Modal overlay displaying keyboard and touch control instructions
const ControlsModal: React.FC<ControlsModalProps> = ({ onClose }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal" onClick={e => e.stopPropagation()}>
      <h2>Controls</h2>
      <h3>Keyboard</h3>
      <ul>
        <li><strong>← / →</strong>: Move left/right</li>
        <li><strong>↑</strong>: Rotate</li>
        <li><strong>↓</strong>: Soft drop</li>
        <li><strong>Hard drop</strong>: Tap ↓ twice quickly or use hard drop button</li>
      </ul>
      <h3>Touch</h3>
      <ul>
        <li><strong>◀ / ▶</strong>: Move left/right</li>
        <li><strong>⟳</strong>: Rotate</li>
        <li><strong>↓</strong>: Soft drop</li>
        <li><strong>⇓</strong>: Hard drop</li>
      </ul>
      <button className="modal-close" onClick={onClose}>Close</button>
    </div>
  </div>
);

export default React.memo(ControlsModal);